import { Modal, Form, Input, DatePicker, Select, Button, Space } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import { useState } from 'react';

const ChequeAssignmentModal = ({ visible, onCancel, onSubmit, cessionData, banques }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        numeroCheque: '',
        banque: '',
        dateEmission: null,
        montant: parseInt(cessionData?.soldeMontant || 0),
        observations: ''
    });

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            console.log("Cession Data:", cessionData);
            // Formater les données avant soumission
            const chequeData = {
                numeroCheque: values.numeroCheque,
                banque: values.banque,
                dateCheque: values.dateEmission?.format('YYYY-MM-DD'),
                montantCheque: formData.montant,
                observations: values.observations,
                codeId: cessionData?.codeId,
                categorie: { categorieCode: cessionData?.categorieCode },
                compagnie: cessionData?.compagnie,
                moisRapport: cessionData?.moisRapport
            };

            console.log('Données du chèque à soumettre:', chequeData);

            await onSubmit(chequeData);
            form.resetFields();
            setLoading(false);
        } catch (error) {
            console.error('Erreur de validation:', error);
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    // Liste des banques courantes (à adapter selon vos besoins)

    return (
        <Modal
            title={
                <Space>
                    <BankOutlined style={{ color: '#F39C12', fontSize: '20px' }} />
                    <span>Assigner un chèque</span>
                </Space>
            }
            open={visible}
            onCancel={handleCancel}
            footer={null}
            width={600}
            destroyOnClose
        >
            <div style={{ marginBottom: '16px', padding: '12px', background: '#f0f5ff', borderRadius: '8px' }}>
                <p style={{ margin: 0, fontSize: '13px', color: '#666' }}>
                    <strong>Catégorie:</strong> {cessionData?.categorieCode}
                </p>
                <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
                    <strong>Montant dû au Pool:</strong>{' '}
                    <span style={{ color: '#52c41a', fontWeight: 600 }}>
                        {parseInt(cessionData?.soldeMontant)?.toLocaleString('fr-FR')} F CFA
                    </span>
                </p>
            </div>

            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    montant: parseInt(cessionData?.soldeMontant)
                }}
            >
                <Form.Item
                    name="numeroCheque"
                    label="Numéro de chèque"
                    rules={[
                        { required: true, message: 'Veuillez saisir le numéro de chèque' },
                        { pattern: /^[0-9]+$/, message: 'Le numéro doit contenir uniquement des chiffres' }
                    ]}
                >
                    <Input
                        placeholder="Ex: 1234567890"
                        maxLength={20}
                        value={formData.numeroCheque}
                        onChange={(e) => setFormData({ ...formData, numeroCheque: e.target.value })}
                    />
                </Form.Item>

                <Form.Item
                    name="banque"
                    label="Banque émettrice"
                    rules={[{ required: true, message: 'Veuillez sélectionner la banque' }]}
                >
                    <Select
                        placeholder="Sélectionnez la banque"
                        showSearch
                        options={banques?.map(b => ({ label: b.libelleParametre, value: b.libelleParametre }))}
                        value={formData.banque}
                        onChange={(value) => setFormData({ ...formData, banque: value })}
                    />
                </Form.Item>

                <Form.Item
                    name="dateEmission"
                    label="Date d'émission du chèque"
                    rules={[{ required: true, message: 'Veuillez sélectionner la date' }]}
                >
                    <DatePicker
                        style={{ width: '100%' }}
                        format="DD/MM/YYYY"
                        placeholder="Sélectionnez la date"
                        onChange={(date, dateString) => setFormData({ ...formData, dateEmission: dateString })}
                        disabledDate={(current) => current && current > new Date()}
                    />
                </Form.Item>

                {/* <Form.Item
                    name="montant"
                    label="Montant du chèque (F CFA)"
                    rules={[
                        { required: true, message: 'Veuillez saisir le montant' },
                    ]}
                >
                    <Input
                        placeholder="Ex: 1000000"
                        suffix="F CFA"
                        type="number"
                        value={formData.montant}
                        onChange={(e) => setFormData({ ...formData, montant: Number(e.target.value) })}
                    />
                    {formData.montant < parseInt(cessionData?.soldeMontant) && (
                        <small style={{ color: '#ff4d4f', marginTop: '4px', display: 'block' }}>
                            Le montant doit être supérieur ou égal au montant dû : {parseInt(cessionData?.soldeMontant)?.toLocaleString('fr-FR')} F CFA
                        </small>
                    )}
                </Form.Item> */}
                <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600 }}>
                        Montant du chèque (F CFA) <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Input
                        placeholder="Ex: 1000000"
                        suffix="F CFA"
                        value={formData.montant}
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            setFormData({ ...formData, montant: value ? Number(value) : 0 });
                        }}
                    />
                    {formData.montant < parseInt(cessionData?.soldeMontant) && (
                        <small style={{ color: '#ff4d4f', marginTop: '4px', display: 'block' }}>
                            Le montant doit être supérieur ou égal au montant dû : {parseInt(cessionData?.soldeMontant)?.toLocaleString('fr-FR')} F CFA
                        </small>
                    )}
                </div>

                <Form.Item
                    name="observations"
                    label="Observations (optionnel)"
                >
                    <Input.TextArea
                        rows={3}
                        placeholder="Remarques ou informations complémentaires..."
                        maxLength={500}
                        showCount
                        value={formData.observations}
                        onChange={(e) => setFormData({ ...formData, observations: e.target.value })}
                    />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0, marginTop: '24px' }}>
                    <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                        <Button onClick={handleCancel}>
                            Annuler
                        </Button>
                        <Button
                            type="primary"
                            onClick={handleSubmit}
                            loading={loading}
                            style={{ background: '#F39C12', borderColor: '#F39C12' }}
                        >
                            Assigner le chèque
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ChequeAssignmentModal;